module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp2_8017.d7842bb0.png";